import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'organizations'
const Actions = crudActions(endpoint)

const ministries = ({ commit }) => new Promise((resolve, reject) => {
  axios.get(`${endpoint}/ministries/`)
    .then(response => {
      commit('MINISTRIES', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const organizations = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/organizations/', { params: queryParams })
    .then(response => {
      commit('LIST', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const excel = (_, status) => new Promise((resolve, reject) => {
  axios.get('/statistics/org_admin_mode', { params: { org_admin_mode: status } })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
export default {
  ...Actions,
  ministries,
  excel,
  organizations,
}
